import { useSettings } from '@backpackjs/storefront';
import Script from 'next/script';

export function BeamCommunityImpactWrapper() {
  const settings = useSettings();
  const beamSettings = settings?.beam;

  if (!beamSettings) return null;

  return (
    <>
      <Script
        strategy="afterInteractive"
        type="module"
        crossOrigin="anonymous"
        src="https://sdk.beamimpact.com/web-sdk/v1.53.1/dist/components/community-impact.esm.js"
      />
      <beam-community-impact
        apiKey={beamSettings.beamApiKey}
        chainId={beamSettings.beamChainId}
        storeId={beamSettings.beamStoreId}
        baseUrl="https://api.beamimpact.com"
        lang="en"
        cardStyle="image"
        class="font-sans"
      />
    </>
  );
}
